module.exports = __webpack_public_path__ + "bitbucket-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/bitbucket-logo.png
// module id = 1251
// module chunks = 74